import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "61",
  height: "60",
  viewBox: "0 0 61 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M23.001 15.795 33.296 5.5v6.51A20.591 20.591 0 1 1 9.91 32.41h6.736a13.855 13.855 0 1 0 16.65-13.57v7.25L23.001 15.796z",
      fill: "#fff"
    }, null, -1)
  ])))
}
export default { render: render }